import styled, { css } from 'styled-components';
import { darken, lighten, desaturate, transparentize } from 'polished';

interface ContainerProps {
  height?: string | number; //Remover o number futuramente;
}
interface TextAreaProps {
  height?: string;
  $error?: string;
}
export const Container = styled.div<ContainerProps>`
  margin-bottom: 0.5rem;
  padding: 0;
  display: flex;
  flex-direction: column;
  width: 100%;

  /* ICON ERROR */
  i {
    text-decoration: none;
    font-style: normal;
    color: ${props => props.theme.error};
    position: absolute;
    align-self: flex-end;
    padding: 0.65rem 0.6rem 0rem 0.6rem;
    svg {
      font-size: 0.875rem;
    }
  }
  div {
    display: flex;
  }
`;

export const RemainingChars = styled.span`
  margin-top: 1.5px;
  font-size: 0.75rem;
  color: ${props => props.theme.fontColor};
`;

export const ErrorMessage = styled.span`
  margin-top: 1.5px;
  display: flex;
  flex: 1 1;
  flex-wrap: wrap;
  font-size: 0.75rem;
  color: ${props => props.theme.error};
`;

export const TextArea = styled.textarea<TextAreaProps>`
  padding: 10px 15px 5px 15px;
  resize: none;
  border-radius: 4px;
  height: ${props =>
    Number(props.height) ? `${props.height}px` : props.height || '38px'};
  min-height: 38px;
  transition: border 0.3s ease;
  color: ${props => props.theme.fontColor};
  background: ${props =>
    props.theme.name === 'dark'
      ? lighten(0.05, props.theme.cardBackgroud)
      : darken(0.01, props.theme.cardBackgroud)};

  border: 1px solid ${props => props.theme.componentborder};
  ${({ $error }) =>
    $error &&
    css`
      border-color: ${props => props.theme.error};
    `}
  &:focus {
    border-color: ${props => desaturate(0.5, props.theme.button.primary.in)};
  }

  &::placeholder {
    opacity: 0.6;
    color: ${props => props.theme.fontColor};
  }

  &:disabled {
    opacity: 0.8;
    color: ${props => transparentize(0.2, props.theme.fontColor)};
    cursor: not-allowed;
  }
`;
